"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SolarWindPower = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var SolarWindPower = (function (_super) {
    __extends(SolarWindPower, _super);
    function SolarWindPower() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.SOLAR_WIND_POWER,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.SPACE, Tags_1.Tags.ENERGY],
            cost: 11,
            metadata: {
                cardNumber: '077',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.energy(1); }).br.titanium(2);
                }),
                description: 'Increase your energy production 1 step and gain 2 titanium.',
            },
        }) || this;
    }
    SolarWindPower.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.ENERGY, 1);
        player.titanium += 2;
        return undefined;
    };
    return SolarWindPower;
}(Card_1.Card));
exports.SolarWindPower = SolarWindPower;
